import { useLayoutEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import styles from './Tooltip.module.css'

export interface TooltipData {
  title: string
  description?: string | null
  /** Viewport coords of the anchor: horizontal center and top edge. */
  x: number
  y: number
}

const EDGE_PADDING = 8

export default function Tooltip ({ tip }: { tip: TooltipData | null }) {
  const bubbleRef = useRef<HTMLDivElement>(null)
  const [shift, setShift] = useState(0)

  // Keep the bubble inside the viewport; the caret stays over the anchor.
  useLayoutEffect(() => {
    const el = bubbleRef.current
    if (!el || !tip) return
    const half = el.offsetWidth / 2
    const overflowLeft = EDGE_PADDING - (tip.x - half)
    const overflowRight = (tip.x + half) - (window.innerWidth - EDGE_PADDING)
    setShift(overflowLeft > 0 ? overflowLeft : (overflowRight > 0 ? -overflowRight : 0))
  }, [tip?.title, tip?.description, tip?.x, tip?.y])

  if (!tip) return null

  return createPortal(
    <div className={styles.tooltip} style={{ left: tip.x, top: tip.y }}>
      <div className={styles.bubble} ref={bubbleRef} style={{ transform: `translateX(${shift}px)` }}>
        <div className={styles.title}>{tip.title}</div>
        {tip.description && <div className={styles.description}>{tip.description}</div>}
      </div>
      <svg className={styles.caret} viewBox="0 0 9 4.66667" fill="none">
        <path d="M2.9 3.86667L0 0H9L6.1 3.86667C5.3 4.93333 3.7 4.93333 2.9 3.86667Z" fill="var(--tooltip-bg)" />
      </svg>
    </div>,
    document.querySelector('#player-root') ?? document.body
  )
}
